export const apiBaseUrl =
  process.env.NODE_ENV === 'development'
    ? 'https://localhost:44363/api'
    : '/api';
